export const DS_CHART_DEFAULT_TOOLTIP_OPTIONS: Chart.ChartTooltipOptions = {
  titleFontSize: 20,
  footerFontSize: 16,
  callbacks: {},
};
